import type { Schemas } from "#shopware";

type NavigationElement = Schemas["Category"] & {
  activeClass?: boolean;
};

const _useBrandNavigation = () => {

  const activeCategoryId = ref<string | null>(null);

  const setActiveCategory = (categoryId: string | null) => {
    activeCategoryId.value = categoryId;
  };

  const hasActiveChild = (children: NavigationElement[]): boolean => {
    return children.some(
      (child) =>
        child.id === activeCategoryId.value ||
        hasActiveChild(child.children || [])
    );
  };

  return {
    activeCatgeory: computed(() => activeCategoryId.value),
    setActiveCategory,
  };
};

export const useBrandNavigation = createSharedComposable(_useBrandNavigation);
